import { render, staticRenderFns } from "./ModalLinkButton.vue?vue&type=template&id=0cb08eb2"
import script from "./ModalLinkButton.vue?vue&type=script&lang=js"
export * from "./ModalLinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports